import { STATIC_DATASET_USAGE_KEY } from '@/utils/queryKeys.ts';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AUTOMATION_KEY, AUTOMATIONS_KEY } from '@/utils/queryKeys.ts';
import { Automation } from '@/types/automations.ts';

const useInvalidateAutomation = (automationId: string) => {
  const queryClient = useQueryClient();

  return useCallback(
    (automation: Automation): unknown[][] => {
      queryClient.setQueryData<Automation>(AUTOMATION_KEY(automationId), automation);
      return [AUTOMATIONS_KEY, STATIC_DATASET_USAGE_KEY(automationId)];
    },
    [automationId, queryClient],
  );
};

export default useInvalidateAutomation;
